export default __webpack_public_path__ + "static/media/ottdock_logo.30805a90.png";